import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=7bb3ffc5&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=7bb3ffc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb3ffc5",
  null
  
)

export default component.exports